// console.time('dsg')
import { Dropdown as Dropdown } from '../node_modules/bootstrap/js/src/dropdown'
import { Collapse as Collapse } from '../node_modules/bootstrap/js/src/collapse'
import { Dsg } from './components/dsg'

const dsg = new Dsg()

/***************************************************************
  Header info banner
***************************************************************/
const siteMainHeader = dsg.qs('#masthead')
const headerInfoBanner = dsg.qs('.site-header__banner')
const root = document.documentElement
const setTopBanner = (root) => {
  const height = headerInfoBanner.offsetHeight

  root.style.setProperty('--info-banner-height', height + 'px')
}
const setHeaderBanner = dsg.debounce(() => {
  setTopBanner(root)
})

// if (siteMainHeader && siteMainHeader.classList.contains('user-logged-in')) {
//   sessionStorage.setItem('headerBanner', 'hidden')
// }

if (headerInfoBanner) {
  const closeBtn = dsg.qs('.site-header__banner__close', headerInfoBanner)
  const sessionStatus = sessionStorage.getItem('headerBanner')
  if (!sessionStatus || sessionStatus !== 'hidden') {
    headerInfoBanner.style.display = 'block'
    setTopBanner(root)
    window.addEventListener('resize', () => {
      setHeaderBanner()
    })
  } else {
    headerInfoBanner.style.display = 'none'
  }

  closeBtn.addEventListener('click', (e) => {
    e.preventDefault()
    sessionStorage.setItem('headerBanner', 'hidden')
    headerInfoBanner.style.display = 'none'
    root.style.setProperty('--info-banner-height', '0px')
  })
}

/***************************************************************
  DSG Popup modal
***************************************************************/

const dsgPoupModal = dsg.qs('#dsg-popup-modal')
const closeModal = dsg.qs('.dsg-popup-modal__close')
const takeSurvey = dsg.qs('#btn-take-survey')
const isPopupClosed = sessionStorage.getItem('dsgModalClosed');
const isSurveyOpend = localStorage.getItem('surveyOpend');

const openModal = () => { setTimeout( () => {
  dsgPoupModal.classList.add('dsg-modal-open')
  }, 10000)
}

if(!isPopupClosed && !isSurveyOpend) {
  openModal(); 
}

closeModal.addEventListener('click', () => {
  dsgPoupModal.classList.remove('dsg-modal-open');
  sessionStorage.setItem('dsgModalClosed', true);
})

takeSurvey.addEventListener('click', () => {
  dsgPoupModal.classList.remove('dsg-modal-open');
  localStorage.setItem('surveyOpend', true);
})

/***************************************************************
  Home page
***************************************************************/
dsg.slider('.home-glide-slider-1', 5000)
dsg.slider('.home-glide-slider-2', 5000)

/***************************************************************
  Propose content form
***************************************************************/
const cf7TeatAreas = dsg.qsa('.dsg-cf7-form .c-text-area')
cf7TeatAreas.forEach((cf7TextArea) => {
  const hasCount = cf7TextArea.classList.contains('has-word-count')
  if (hasCount) {
    if (cf7TextArea.classList.contains('word-count-300')) {
      dsg.countTextAreaLength(cf7TextArea, 250)
    }
    if (cf7TextArea.classList.contains('word-count-100')) {
      dsg.countTextAreaLength(cf7TextArea, 100)
    }
  }
})

/***************************************************************
  Resources landing
***************************************************************/

//Scroll menu
const resourcesNavigation = dsg.qs('.resources-navigation')
if (resourcesNavigation) {
  const navLinks = dsg.qsa('.resources-navigation__menu ul li a', resourcesNavigation)
  const featuredSections = dsg.qsa('.resources--featured')

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          navLinks.forEach((link) => {
            link.classList.remove('active')
          })
          const intersectionNav = dsg.qs(
            `a[data-target="#${entry.target.dataset.section}"]`,
            resourcesNavigation
          )
          intersectionNav.classList.add('active')
          // if (navUl) {
          //   const scrollValue = navUlScroll.get(`#${entry.target.dataset.section}`)
          //   navUl.style.transform = `translateX(-${scrollValue}px)`
          // }
        }
      })
    },
    { threshold: 1 }
  )

  featuredSections.forEach((section) => {
    observer.observe(section)
  })
}

//glide
dsg.slider('.resources__posts__mobile-grid', false, 16)

/***************************************************************
  Search and Filter
***************************************************************/
const filterContainer = dsg.qs('.filters-section')

const sorOrderMobile = (archiveMain, sortOrder) => {
  const archiveTop = archiveMain.getBoundingClientRect().top
  const archiveRight = archiveMain.getBoundingClientRect().right
  if (sortOrder) {
    sortOrder.style.top = `${archiveTop}px`
    sortOrder.style.right = `-${archiveRight}px`
  }
}

const addReadMore = (section) => {
  const readMore = document.createElement('A')
  readMore.innerHTML = 'View more'
  readMore.classList.add('read-more')
  section.append(readMore)
}

if (filterContainer) {
  const filterForm = dsg.qs('.searchandfilter', filterContainer)
  const resetContainer = dsg.qs('.sf-field-reset', filterForm)
  const resetButton = dsg.qsa('.search-filter-reset', filterContainer)
  const mobileFiltersBtn = dsg.qs('.mobile-filters-btn')
  const submitBtn = dsg.qs('.sf-field-submit', filterContainer)
  const closeBtn = dsg.qsa('.close-filter-section')
  const mobileLayoutBtn = dsg.qs('.mobile-layout-change ')
  const archiveMain = dsg.qs('.posts-archive__main')
  const postType = filterContainer.dataset.postType
  const sortOrder = dsg.qs('.sf-field-sort_order', filterContainer)
  const dateFieldsContainer = dsg.qs('.sf-field-post_date', filterContainer)
  const datePickers = dsg.qsa('.sf_date_field li', dateFieldsContainer)
  const urlParams = new URLSearchParams(window.location.search)
  const mainSearchInput = dsg.qs('.main-search__form .searchandfilter .sf-input-text')
  const mainSearchSubmit = dsg.qs('.main-search__form .searchandfilter .sf-field-submit input')

  const clearResetSection = dsg.matchMedia(() => {
    resetContainer.style.display = 'none'
  }, 'min-width:992px')

  const newDiv = document.createElement('DIV')
  newDiv.classList.add('selected-filters')
  resetContainer.prepend(newDiv)

  const filterSections = dsg.qsa('.searchandfilter > ul > li', filterContainer)

  dsg.filterSelectedItems(newDiv, filterContainer, '', urlParams.get('_sf_s'))

  // if (dateFieldsContainer) {
  //   datePickers.forEach((datePicker) => {
  //     const pickerInput = dsg.qs('.sf-datepicker ', datePicker)

  //     const clearBtn = document.createElement('A')
  //     clearBtn.classList.add('clear-date')
  //     clearBtn.innerHTML = `<span class="icon-close"></span>`

  //     datePicker.append(clearBtn)

  //     clearBtn.addEventListener('click', (e) => {
  //       e.preventDefault()
  //       pickerInput.value = ''
  //     })
  //   })
  // }

  //accordion
  filterSections.forEach((section) => {
    const sectionHeader = dsg.qs('h4', section)
    if (sectionHeader) {
      let sectionOpen = true
      let viewMoreActive = false
      sectionHeader.addEventListener('click', (e) => {
        e.preventDefault()
        section.classList.toggle('hidden')
        sectionOpen = !sectionOpen
      })

      const checkboxSection = dsg.qs('ul', section)

      if (checkboxSection.scrollHeight > 190) {
        addReadMore(checkboxSection)
        const viewMoreBtn = dsg.qs('.read-more', checkboxSection)
        viewMoreActive = true

        if (sectionOpen && viewMoreActive) {
          checkboxSection.classList.add('items-hidden')
          viewMoreBtn.addEventListener('click', (e) => {
            e.preventDefault()
            checkboxSection.classList.toggle('items-hidden')
            viewMoreBtn.innerHTML = viewMoreActive ? 'View less' : 'View more'
            viewMoreActive = !viewMoreActive
          })
        }
      }
    }
  })

  filterForm.addEventListener('change', (e) => {
    const params = new URLSearchParams(window.location.search)
    let searchText = null
    let title = postType
    if (params.has('_sf_s')) {
      title = 'Search Results'
      searchText = params.get('_sf_s')
    } else if (params.has('title')) {
      title = params.get('title')
    } else {
      title = postType
    }
    dsg.filterSelectedItems(newDiv, filterContainer, title, searchText)
  })

  resetButton.forEach((resetBtn) => {
    resetBtn.addEventListener('click', () => {
      newDiv.innerHTML = ''
      //newDiv.style.display = 'none'
      mainSearchInput.value = ''
      document.querySelector('.main-page-title').innerHTML = postType
      //Close mobile filters
      dsg.mobileFilters(false, filterContainer)
      clearResetSection()
      if (mobileFiltersBtn) {
        mobileFiltersBtn.classList.remove('has-active-filters')
      }
    })
  })

  //Open Mobile filters
  if (mobileFiltersBtn) {
    mobileFiltersBtn.addEventListener('click', (e) => {
      e.preventDefault()
      dsg.mobileFilters(true, filterContainer)
    })
  }

  //Close Mobile filters
  submitBtn.addEventListener('click', (e) => {
    dsg.mobileFilters(false, filterContainer)
  })

  mainSearchSubmit.addEventListener('click', (e) => {
    if (mainSearchInput.value !== '') {
      dsg.filterSelectedItems(newDiv, filterContainer, 'Search Results', mainSearchInput.value)
    }
  })

  closeBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      dsg.mobileFilters(false, filterContainer)
    })
  })

  mobileLayoutBtn.addEventListener('click', (e) => {
    e.preventDefault()
    archiveMain.classList.toggle('list-view-active')
    mobileLayoutBtn.classList.toggle('list-view-active')
  })

  sorOrderMobile(archiveMain, sortOrder)
  window.addEventListener('scroll', () => {
    sorOrderMobile(archiveMain, sortOrder)
  })
  window.addEventListener('resize', () => {
    sorOrderMobile(archiveMain, sortOrder)
  })

  if (dateFieldsContainer) {
    const datePickerInputs = dsg.qsa('.sf-datepicker', dateFieldsContainer)
    datePickerInputs.forEach((input) => {
      if (dsg.isMobile()) {
        input.setAttribute('readonly', 'readonly')
      }
    })
  }
}

//Community filters
const communityFilters = dsg.qs('.community-filter')
if (communityFilters) {
  const filterSections = dsg.qsa('.dsg-bps-filter-section', communityFilters)
  const mobileFiltersBtn = dsg.qs('.mobile-filters-btn')
  const closeBtn = dsg.qsa('.close-filter-section')

  //accordion
  filterSections.forEach((section) => {
    const sectionHeader = dsg.qs('.dsg-bps-filter-title', section)
    if (sectionHeader) {
      let sectionOpen = true
      let viewMoreActive = false
      sectionHeader.addEventListener('click', (e) => {
        e.preventDefault()
        section.classList.toggle('hidden')
        sectionOpen = !sectionOpen
      })
      const checkboxSection = dsg.qs('.dsg-bps-filter-content', section)

      if (checkboxSection.scrollHeight > 190) {
        addReadMore(checkboxSection)
        const viewMoreBtn = dsg.qs('.read-more', checkboxSection)
        viewMoreActive = true

        if (sectionOpen && viewMoreActive) {
          checkboxSection.classList.add('items-hidden')
          viewMoreBtn.addEventListener('click', (e) => {
            e.preventDefault()
            checkboxSection.classList.toggle('items-hidden')
            viewMoreBtn.innerHTML = viewMoreActive ? 'View less' : 'View more'
            viewMoreActive = !viewMoreActive
          })
        }
      }
    }
  })

  //Open Mobile filters
  if (mobileFiltersBtn) {
    mobileFiltersBtn.addEventListener('click', (e) => {
      e.preventDefault()
      dsg.mobileFilters(true, communityFilters)
    })
  }

  if (closeBtn) {
    closeBtn.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        dsg.mobileFilters(false, communityFilters)
      })
    })
  }
}

/***************************************************************
  Comments module
***************************************************************/

const commentsModule = dsg.qs('.post-single__comments')

if (commentsModule) {
  const commentForm = dsg.qs('.comment-form', commentsModule)
  const viewAllBtn = dsg.qs('.view-all-comments', commentsModule)
  const commentsList = dsg.qs('.comment-list', commentsModule)
  let viewAllStatus = false
  const commentHiddenHeight = 320

  if (commentsList) {
    if (commentsList.scrollHeight < commentHiddenHeight) {
      viewAllBtn.style.display = 'none'
      commentsList.classList.remove('hidden')
    } else {
      commentsList.style.height = `${commentHiddenHeight}px`
      commentsList.classList.add('hidden')
    }

    if (window.location.hash && commentsList.scrollHeight > commentHiddenHeight) {
      viewAllStatus = true
      viewAllBtn.classList.add('active')
      dsg.qs('span', viewAllBtn).innerHTML = 'View less comments'
      commentsList.style.height = `${commentsList.scrollHeight}px`
    }

    viewAllBtn.addEventListener('click', (e) => {
      if (viewAllStatus) {
        commentsList.style.height = `${commentHiddenHeight}px`
        viewAllBtn.classList.remove('active')
        dsg.qs('span', viewAllBtn).innerHTML = 'View all comments'
        viewAllStatus = false
      } else {
        commentsList.style.height = `${commentsList.scrollHeight}px`
        viewAllBtn.classList.add('active')
        dsg.qs('span', viewAllBtn).innerHTML = 'View less comments'
        viewAllStatus = true
      }
    })
  } else {
    viewAllBtn.style.display = 'none'
  }

  if (commentForm) {
    const commentTextarea = dsg.qs('textarea', commentForm)
    const commentsSubmit = dsg.qs('#submit', commentForm)

    commentTextarea.setAttribute('placeholder', 'Leave a comment')
    commentsSubmit.setAttribute('disabled', 'disabled')

    commentTextarea.addEventListener('input', (e) => {
      e.target.style.height = '1px'
      e.target.style.height = e.target.scrollHeight + 'px'

      if (e.target.value) {
        commentsSubmit.removeAttribute('disabled')
      } else {
        commentsSubmit.setAttribute('disabled', 'disabled')
      }
    })
  }
}

/***************************************************************
  Search section updates
***************************************************************/
const mainSearch = dsg.qsa('.main-search__form')
const memberSearch = dsg.qsa('.bp-dir-search-form')

const showCloseIcon = (icon, input) => {
  if (input.value !== '') {
    icon.style.opacity = 1
  } else {
    icon.style.opacity = 0
  }
}

mainSearch.forEach((search) => {
  const searchInput = dsg.qs('.sf-input-text', search)
  const searchBtnContainer = dsg.qs('.sf-field-submit', search)

  const newI = document.createElement('I')
  newI.classList.add('icon-close')
  newI.style.opacity = 0
  searchBtnContainer.prepend(newI)

  newI.addEventListener('click', (e) => {
    e.preventDefault()
    searchInput.value = ''
    newI.style.opacity = 0
  })

  showCloseIcon(newI, searchInput)

  searchInput.addEventListener('input', (e) => {
    showCloseIcon(newI, searchInput)
  })
})

memberSearch.forEach((search) => {
  const searchInput = dsg.qs('#dir-members-search', search)
  const icon = dsg.qs('i', search)
  icon.addEventListener('click', (e) => {
    e.preventDefault()
    searchInput.value = ''
    icon.style.opacity = 0
  })
  showCloseIcon(icon, searchInput)
  searchInput.addEventListener('input', (e) => {
    showCloseIcon(icon, searchInput)
  })
})

/***************************************************************
  Community auto filter
***************************************************************/
const communityFilterForm = dsg.qsa('.bps-form')
const mediaQuery = window.matchMedia('(min-width: 992px)')
const submitForm = dsg.debounce((form) => {
  form.submit()
})
const filterForm = dsg.matchMedia((communityForm) => {
  const filterDisplay = dsg.qs('.dsg-bps-filter-section', communityForm)
  const filteredItems = dsg.qs('.bps-filters__items', filterDisplay)
  if (filteredItems.textContent.trim() === '') {
    filterDisplay.style.display = 'none'
  }

  dsg.qs('.dsg-bps-submit', communityForm).style.display = 'none'
  communityForm.addEventListener('change', (e) => {
    submitForm(communityForm)
  })
}, 'min-width:992px')

communityFilterForm.forEach((communityForm) => {
  filterForm(communityForm)
})

// console.timeEnd('dsg')